import VerticalAlignBottomIcon from '@mui/icons-material/VerticalAlignBottom';
import VerticalAlignTopIcon from '@mui/icons-material/VerticalAlignTop';
import { Grid } from '@mui/material';
import ButtonSecondary from 'components/Button/ButtonSecondary';
import { useNavigate } from 'react-router-dom';

const ActionSection = () => {
    const navigate = useNavigate();

    return (
        <Grid container sx={{ flexWrap: { md: 'nowrap', sm: 'nowrap', xs: 'wrap' } }} gap={2}>
            <Grid item xs={12} sm={6} md={4}>
                <ButtonSecondary
                    size="medium"
                    title="deposit-text"
                    icon={<VerticalAlignBottomIcon fontSize="small" />}
                    positionIcon="left"
                    type="button"
                    onClick={() => navigate(`/merchant/wallet-detail/USDT`)}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <ButtonSecondary
                    size="medium"
                    title="withdraw-text"
                    icon={<VerticalAlignTopIcon fontSize="small" />}
                    positionIcon="left"
                    type="button"
                    onClick={() => navigate(`/merchant/wallet-detail/USDT`)}
                />
            </Grid>

            {/* <Grid item xs={12} sm={6} md={4}>
                <ButtonSecondary
                    size="medium"
                    title="swap"
                    icon={<SyncAltIcon fontSize="small" />}
                    positionIcon="left"
                    type="button"
                    onClick={handleClickSend}
                />
            </Grid> */}
        </Grid>
    );
};

export default ActionSection;
